import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export default function NotFoundPage() {
  const navigate  = useNavigate()
  const { user }  = useAuth()
  return (
    <div style={{ minHeight:'100vh', background:'#FAFAF8', display:'flex', alignItems:'center', justifyContent:'center', padding:'2rem', textAlign:'center' }}>
      <div style={{ maxWidth:460 }}>
        <p style={{ fontFamily:'Gibs, serif', fontSize:'7rem', color:'rgba(196,130,106,0.15)', lineHeight:1, margin:'0 0 0.5rem', userSelect:'none' }}>404</p>
        <h1 style={{ fontFamily:'Gibs, serif', fontWeight:400, fontSize:'1.75rem', color:'#1A1A1A', margin:'0 0 0.75rem' }}>
          This page doesn't exist
        </h1>
        <p style={{ fontFamily:'Nunito Sans, sans-serif', fontSize:'0.9rem', color:'#6B6B6B', lineHeight:1.7, margin:'0 0 2rem' }}>
          The link you followed may be broken, or the page may have been removed.
        </p>
        <div style={{ display:'flex', gap:'0.75rem', justifyContent:'center', flexWrap:'wrap' }}>
          <button onClick={()=>navigate(-1)} className="btn-secondary" style={{ fontSize:'0.875rem' }}>
            ← Go back
          </button>
          <button onClick={()=>navigate(user ? '/dashboard' : '/')} className="btn-primary" style={{ fontSize:'0.875rem' }}>
            {user ? 'Back to Dashboard' : 'Go Home'}
          </button>
        </div>
      </div>
    </div>
  )
}
